import { languages, getLanguage } from './lang';
import keys from './lang/keys';

const messages = Object.assign(languages);

export default class ContentTransform {
  constructor(options) {
    this.itemIdentifiers = options.itemIdentifiers || {};
    this.modules = options.modules || {};
    this.onRetrieveData = options.onRetrieveData;
    this.afterRetrieveData = options.afterRetrieveData;
    this.onError = options.onError;
    this.lang = keys;
    this.selectedLanguage = options.selectedLanguage;

    this.translate = (key, lang) => {
      let language;

      if (lang || (this.selectedLanguage && typeof this.selectedLanguage === 'function')) {
        language = this.selectedLanguage();
      } else {
        language = getLanguage();
      }

      return messages[language][key];
    };
  }
}
